export default __webpack_public_path__ + "static/media/restaurant-6-rMAX.662ff9d8.jpg";